/*! promise-polyfill - v8.2.3 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t():"function"==typeof define&&define.amd?define(t):t()}(0,function(){"use strict";function e(e){var t=this.constructor;return this.then(function(n){return t.resolve(e()).then(function(){return n})},function(n){return t.resolve(e()).then(function(){return t.reject(n)})})}function t(e){return new this(function(t,n){function o(e,n){if(n&&("object"==typeof n||"function"==typeof n)){var f=n.then;if("function"==typeof f)return void f.call(n,function(t){o(e,t)},function(n){r[e]={status:"rejected",reason:n},0==--i&&t(r)})}r[e]={status:"fulfilled",value:n},0==--i&&t(r)}if(!e||"undefined"==typeof e.length)return n(new TypeError(typeof e+" "+e+" is not iterable(cannot read property Symbol(Symbol.iterator))"));var r=Array.prototype.slice.call(e);if(0===r.length)return t([]);for(var i=r.length,f=0;r.length>f;f++)o(f,r[f])})}function n(e){return!(!e||"undefined"==typeof e.length)}function o(){}function r(e){if(!(this instanceof r))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],l(e,this)}function i(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,r._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var o;try{o=n(e._value)}catch(r){return void u(t.promise,r)}f(t.promise,o)}else(1===e._state?f:u)(t.promise,e._value)})):e._deferreds.push(t)}function f(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof r)return e._state=3,e._value=t,void c(e);if("function"==typeof n)return void l(function(e,t){return function(){e.apply(t,arguments)}}(n,t),e)}e._state=1,e._value=t,c(e)}catch(o){u(e,o)}}function u(e,t){e._state=2,e._value=t,c(e)}function c(e){2===e._state&&0===e._deferreds.length&&r._immediateFn(function(){e._handled||r._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;n>t;t++)i(e,e._deferreds[t]);e._deferreds=null}function l(e,t){var n=!1;try{e(function(e){n||(n=!0,f(t,e))},function(e){n||(n=!0,u(t,e))})}catch(o){if(n)return;n=!0,u(t,o)}}var a=setTimeout;r.prototype["catch"]=function(e){return this.then(null,e)},r.prototype.then=function(e,t){var n=new this.constructor(o);return i(this,new function(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}(e,t,n)),n},r.prototype["finally"]=e,r.all=function(e){return new r(function(t,o){function r(e,n){try{if(n&&("object"==typeof n||"function"==typeof n)){var u=n.then;if("function"==typeof u)return void u.call(n,function(t){r(e,t)},o)}i[e]=n,0==--f&&t(i)}catch(c){o(c)}}if(!n(e))return o(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},r.allSettled=t,r.resolve=function(e){return e&&"object"==typeof e&&e.constructor===r?e:new r(function(t){t(e)})},r.reject=function(e){return new r(function(t,n){n(e)})},r.race=function(e){return new r(function(t,o){if(!n(e))return o(new TypeError("Promise.race accepts an array"));for(var i=0,f=e.length;f>i;i++)r.resolve(e[i]).then(t,o)})},r._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},r._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var s=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"function"!=typeof s.Promise?s.Promise=r:(s.Promise.prototype["finally"]||(s.Promise.prototype["finally"]=e),s.Promise.allSettled||(s.Promise.allSettled=t))});

/*! deepmerge - v4.2.2 */
// !function(e,r){"object"==typeof exports&&"undefined"!=typeof module?module.exports=r():"function"==typeof define&&define.amd?define(r):(e=e||self).deepmerge=r()}(this,function(){"use strict";var e=function(e){return function(e){return!!e&&"object"==typeof e}(e)&&!function(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||function(e){return e.$$typeof===r}(e)}(e)};var r="function"==typeof Symbol&&Symbol.for?Symbol.for("react.element"):60103;function t(e,r){return!1!==r.clone&&r.isMergeableObject(e)?i((t=e,Array.isArray(t)?[]:{}),e,r):e;var t}function n(e,r,n){return e.concat(r).map(function(e){return t(e,n)})}function o(e){return Object.keys(e).concat(function(e){return Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(e).filter(function(r){return e.propertyIsEnumerable(r)}):[]}(e))}function c(e,r){try{return r in e}catch(e){return!1}}function u(e,r,n){var u={};return n.isMergeableObject(e)&&o(e).forEach(function(r){u[r]=t(e[r],n)}),o(r).forEach(function(o){(function(e,r){return c(e,r)&&!(Object.hasOwnProperty.call(e,r)&&Object.propertyIsEnumerable.call(e,r))})(e,o)||(c(e,o)&&n.isMergeableObject(r[o])?u[o]=function(e,r){if(!r.customMerge)return i;var t=r.customMerge(e);return"function"==typeof t?t:i}(o,n)(e[o],r[o],n):u[o]=t(r[o],n))}),u}function i(r,o,c){(c=c||{}).arrayMerge=c.arrayMerge||n,c.isMergeableObject=c.isMergeableObject||e,c.cloneUnlessOtherwiseSpecified=t;var i=Array.isArray(o);return i===Array.isArray(r)?i?c.arrayMerge(r,o,c):u(r,o,c):t(o,c)}return i.all=function(e,r){if(!Array.isArray(e))throw new Error("first argument should be an array");return e.reduce(function(e,t){return i(e,t,r)},{})},i});

/*! lazyload - v17.8.2 */
!function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).LazyLoad=t()}(this,(function(){"use strict";function n(){return n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n},n.apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),a=t&&window.devicePixelRatio>1,r={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_bg_set:"bg-set",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1,restore_on_error:!1},c=function(t){return n({},r,t)},l=function(n,t){var e,i="LazyLoad::Initialized",o=new n(t);try{e=new CustomEvent(i,{detail:{instance:o}})}catch(n){(e=document.createEvent("CustomEvent")).initCustomEvent(i,!1,!1,{instance:o})}window.dispatchEvent(e)},u="src",s="srcset",d="sizes",f="poster",_="llOriginalAttrs",g="data",v="loading",b="loaded",m="applied",p="error",h="native",E="data-",I="ll-status",y=function(n,t){return n.getAttribute(E+t)},k=function(n){return y(n,I)},w=function(n,t){return function(n,t,e){var i="data-ll-status";null!==e?n.setAttribute(i,e):n.removeAttribute(i)}(n,0,t)},A=function(n){return w(n,null)},L=function(n){return null===k(n)},O=function(n){return k(n)===h},x=[v,b,m,p],C=function(n,t,e,i){n&&(void 0===i?void 0===e?n(t):n(t,e):n(t,e,i))},N=function(n,t){o?n.classList.add(t):n.className+=(n.className?" ":"")+t},M=function(n,t){o?n.classList.remove(t):n.className=n.className.replace(new RegExp("(^|\\s+)"+t+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},z=function(n){return n.llTempImage},T=function(n,t){if(t){var e=t._observer;e&&e.unobserve(n)}},R=function(n,t){n&&(n.loadingCount+=t)},G=function(n,t){n&&(n.toLoadCount=t)},j=function(n){for(var t,e=[],i=0;t=n.children[i];i+=1)"SOURCE"===t.tagName&&e.push(t);return e},D=function(n,t){var e=n.parentNode;e&&"PICTURE"===e.tagName&&j(e).forEach(t)},H=function(n,t){j(n).forEach(t)},V=[u],F=[u,f],B=[u,s,d],J=[g],P=function(n){return!!n[_]},S=function(n){return n[_]},U=function(n){return delete n[_]},$=function(n,t){if(!P(n)){var e={};t.forEach((function(t){e[t]=n.getAttribute(t)})),n[_]=e}},q=function(n,t){if(P(n)){var e=S(n);t.forEach((function(t){!function(n,t,e){e?n.setAttribute(t,e):n.removeAttribute(t)}(n,t,e[t])}))}},K=function(n,t,e){N(n,t.class_applied),w(n,m),e&&(t.unobserve_completed&&T(n,t),C(t.callback_applied,n,e))},Q=function(n,t,e){N(n,t.class_loading),w(n,v),e&&(R(e,1),C(t.callback_loading,n,e))},W=function(n,t,e){e&&n.setAttribute(t,e)},X=function(n,t){W(n,d,y(n,t.data_sizes)),W(n,s,y(n,t.data_srcset)),W(n,u,y(n,t.data_src))},Y={IMG:function(n,t){D(n,(function(n){$(n,B),X(n,t)})),$(n,B),X(n,t)},IFRAME:function(n,t){$(n,V),W(n,u,y(n,t.data_src))},VIDEO:function(n,t){H(n,(function(n){$(n,V),W(n,u,y(n,t.data_src))})),$(n,F),W(n,f,y(n,t.data_poster)),W(n,u,y(n,t.data_src)),n.load()},OBJECT:function(n,t){$(n,J),W(n,g,y(n,t.data_src))}},Z=["IMG","IFRAME","VIDEO","OBJECT"],nn=function(n,t){!t||function(n){return n.loadingCount>0}(t)||function(n){return n.toLoadCount>0}(t)||C(n.callback_finish,t)},tn=function(n,t,e){n.addEventListener(t,e),n.llEvLisnrs[t]=e},en=function(n,t,e){n.removeEventListener(t,e)},on=function(n){return!!n.llEvLisnrs},an=function(n){if(on(n)){var t=n.llEvLisnrs;for(var e in t){var i=t[e];en(n,e,i)}delete n.llEvLisnrs}},rn=function(n,t,e){!function(n){delete n.llTempImage}(n),R(e,-1),function(n){n&&(n.toLoadCount-=1)}(e),M(n,t.class_loading),t.unobserve_completed&&T(n,e)},cn=function(n,t,e){var i=z(n)||n;on(i)||function(n,t,e){on(n)||(n.llEvLisnrs={});var i="VIDEO"===n.tagName?"loadeddata":"load";tn(n,i,t),tn(n,"error",e)}(i,(function(o){!function(n,t,e,i){var o=O(t);rn(t,e,i),N(t,e.class_loaded),w(t,b),C(e.callback_loaded,t,i),o||nn(e,i)}(0,n,t,e),an(i)}),(function(o){!function(n,t,e,i){var o=O(t);rn(t,e,i),N(t,e.class_error),w(t,p),C(e.callback_error,t,i),e.restore_on_error&&q(t,B),o||nn(e,i)}(0,n,t,e),an(i)}))},ln=function(n,t,e){!function(n){return Z.indexOf(n.tagName)>-1}(n)?function(n,t,e){!function(n){n.llTempImage=document.createElement("IMG")}(n),cn(n,t,e),function(n){P(n)||(n[_]={backgroundImage:n.style.backgroundImage})}(n),function(n,t,e){var i=y(n,t.data_bg),o=y(n,t.data_bg_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage='url("'.concat(r,'")'),z(n).setAttribute(u,r),Q(n,t,e))}(n,t,e),function(n,t,e){var i=y(n,t.data_bg_multi),o=y(n,t.data_bg_multi_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage=r,K(n,t,e))}(n,t,e),function(n,t,e){var i=y(n,t.data_bg_set);if(i){var o=i.split("|"),a=o.map((function(n){return"image-set(".concat(n,")")}));n.style.backgroundImage=a.join(),""===n.style.backgroundImage&&(a=o.map((function(n){return"-webkit-image-set(".concat(n,")")})),n.style.backgroundImage=a.join()),K(n,t,e)}}(n,t,e)}(n,t,e):function(n,t,e){cn(n,t,e),function(n,t,e){var i=Y[n.tagName];i&&(i(n,t),Q(n,t,e))}(n,t,e)}(n,t,e)},un=function(n){n.removeAttribute(u),n.removeAttribute(s),n.removeAttribute(d)},sn=function(n){D(n,(function(n){q(n,B)})),q(n,B)},dn={IMG:sn,IFRAME:function(n){q(n,V)},VIDEO:function(n){H(n,(function(n){q(n,V)})),q(n,F),n.load()},OBJECT:function(n){q(n,J)}},fn=function(n,t){(function(n){var t=dn[n.tagName];t?t(n):function(n){if(P(n)){var t=S(n);n.style.backgroundImage=t.backgroundImage}}(n)})(n),function(n,t){L(n)||O(n)||(M(n,t.class_entered),M(n,t.class_exited),M(n,t.class_applied),M(n,t.class_loading),M(n,t.class_loaded),M(n,t.class_error))}(n,t),A(n),U(n)},_n=["IMG","IFRAME","VIDEO"],gn=function(n){return n.use_native&&"loading"in HTMLImageElement.prototype},vn=function(n,t,e){n.forEach((function(n){return function(n){return n.isIntersecting||n.intersectionRatio>0}(n)?function(n,t,e,i){var o=function(n){return x.indexOf(k(n))>=0}(n);w(n,"entered"),N(n,e.class_entered),M(n,e.class_exited),function(n,t,e){t.unobserve_entered&&T(n,e)}(n,e,i),C(e.callback_enter,n,t,i),o||ln(n,e,i)}(n.target,n,t,e):function(n,t,e,i){L(n)||(N(n,e.class_exited),function(n,t,e,i){e.cancel_on_exit&&function(n){return k(n)===v}(n)&&"IMG"===n.tagName&&(an(n),function(n){D(n,(function(n){un(n)})),un(n)}(n),sn(n),M(n,e.class_loading),R(i,-1),A(n),C(e.callback_cancel,n,t,i))}(n,t,e,i),C(e.callback_exit,n,t,i))}(n.target,n,t,e)}))},bn=function(n){return Array.prototype.slice.call(n)},mn=function(n){return n.container.querySelectorAll(n.elements_selector)},pn=function(n){return function(n){return k(n)===p}(n)},hn=function(n,t){return function(n){return bn(n).filter(L)}(n||mn(t))},En=function(n,e){var o=c(n);this._settings=o,this.loadingCount=0,function(n,t){i&&!gn(n)&&(t._observer=new IntersectionObserver((function(e){vn(e,n,t)}),function(n){return{root:n.container===document?null:n.container,rootMargin:n.thresholds||n.threshold+"px"}}(n)))}(o,this),function(n,e){t&&(e._onlineHandler=function(){!function(n,t){var e;(e=mn(n),bn(e).filter(pn)).forEach((function(t){M(t,n.class_error),A(t)})),t.update()}(n,e)},window.addEventListener("online",e._onlineHandler))}(o,this),this.update(e)};return En.prototype={update:function(n){var t,o,a=this._settings,r=hn(n,a);G(this,r.length),!e&&i?gn(a)?function(n,t,e){n.forEach((function(n){-1!==_n.indexOf(n.tagName)&&function(n,t,e){n.setAttribute("loading","lazy"),cn(n,t,e),function(n,t){var e=Y[n.tagName];e&&e(n,t)}(n,t),w(n,h)}(n,t,e)})),G(e,0)}(r,a,this):(o=r,function(n){n.disconnect()}(t=this._observer),function(n,t){t.forEach((function(t){n.observe(t)}))}(t,o)):this.loadAll(r)},destroy:function(){this._observer&&this._observer.disconnect(),t&&window.removeEventListener("online",this._onlineHandler),mn(this._settings).forEach((function(n){U(n)})),delete this._observer,delete this._settings,delete this._onlineHandler,delete this.loadingCount,delete this.toLoadCount},loadAll:function(n){var t=this,e=this._settings;hn(n,e).forEach((function(n){T(n,t),ln(n,e,t)}))},restoreAll:function(){var n=this._settings;mn(n).forEach((function(t){fn(t,n)}))}},En.load=function(n,t){var e=c(t);ln(n,e)},En.resetStatus=function(n){A(n)},t&&function(n,t){if(t)if(t.length)for(var e,i=0;e=t[i];i+=1)l(n,e);else l(n,t)}(En,window.lazyLoadOptions),En}));

/*! pinch-zoom-js v2.3.5 */
(function(){"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(a){if(null==a)throw new TypeError("Cannot convert undefined or null to object");for(var b,c=Object(a),d=1;d<arguments.length;d++)if(b=arguments[d],null!=b)for(var e in b)Object.prototype.hasOwnProperty.call(b,e)&&(c[e]=b[e]);return c},writable:!0,configurable:!0}),"function"!=typeof Array.from&&(Array.from=function(a){return[].slice.call(a)});var buildElement=function(a){var b=document.implementation.createHTMLDocument("");return b.body.innerHTML=a,Array.from(b.body.children)[0]},triggerEvent=function(a,b){var c=document.createEvent("HTMLEvents");c.initEvent(b,!0,!1),a.dispatchEvent(c)},definePinchZoom=function(){var a=Math.min,b=Math.max,c=Math.abs,d=function(a,b){this.el=a,this.zoomFactor=1,this.lastScale=1,this.offset={x:0,y:0},this.initialOffset={x:0,y:0},this.options=Object.assign({},this.defaults,b),this.setupMarkup(),this.bindEvents(),this.update(),this.isImageLoaded(this.el)&&(this.updateAspectRatio(),this.setupOffsets()),this.enable()},e=function(c,a){return c+a},f=function(a,b){return a>b-.01&&a<b+.01};d.prototype={defaults:{tapZoomFactor:2,zoomOutFactor:1.3,animationDuration:300,maxZoom:4,minZoom:.5,draggableUnzoomed:!0,lockDragAxis:!1,setOffsetsOnce:!1,use2d:!0,zoomStartEventName:"pz_zoomstart",zoomUpdateEventName:"pz_zoomupdate",zoomEndEventName:"pz_zoomend",dragStartEventName:"pz_dragstart",dragUpdateEventName:"pz_dragupdate",dragEndEventName:"pz_dragend",doubleTapEventName:"pz_doubletap",verticalPadding:0,horizontalPadding:0,onZoomStart:null,onZoomEnd:null,onZoomUpdate:null,onDragStart:null,onDragEnd:null,onDragUpdate:null,onDoubleTap:null},handleDragStart:function(a){triggerEvent(this.el,this.options.dragStartEventName),"function"==typeof this.options.onDragStart&&this.options.onDragStart(this,a),this.stopAnimation(),this.lastDragPosition=!1,this.hasInteraction=!0,this.handleDrag(a)},handleDrag:function(a){var b=this.getTouches(a)[0];this.drag(b,this.lastDragPosition),this.offset=this.sanitizeOffset(this.offset),this.lastDragPosition=b},handleDragEnd:function(){triggerEvent(this.el,this.options.dragEndEventName),"function"==typeof this.options.onDragEnd&&this.options.onDragEnd(this,event),this.end()},handleZoomStart:function(a){triggerEvent(this.el,this.options.zoomStartEventName),"function"==typeof this.options.onZoomStart&&this.options.onZoomStart(this,a),this.stopAnimation(),this.lastScale=1,this.nthZoom=0,this.lastZoomCenter=!1,this.hasInteraction=!0},handleZoom:function(a,b){var c=this.getTouchCenter(this.getTouches(a)),d=b/this.lastScale;this.lastScale=b,this.nthZoom+=1,3<this.nthZoom&&(this.scale(d,c),this.drag(c,this.lastZoomCenter)),this.lastZoomCenter=c},handleZoomEnd:function(){triggerEvent(this.el,this.options.zoomEndEventName),"function"==typeof this.options.onZoomEnd&&this.options.onZoomEnd(this,event),this.end()},handleDoubleTap:function(a){var b=this.getTouches(a)[0],c=1<this.zoomFactor?1:this.options.tapZoomFactor,d=this.zoomFactor,e=function(a){this.scaleTo(d+a*(c-d),b)}.bind(this);this.hasInteraction||(this.isDoubleTap=!0,d>c&&(b=this.getCurrentZoomCenter()),this.animate(this.options.animationDuration,e,this.swing),triggerEvent(this.el,this.options.doubleTapEventName),"function"==typeof this.options.onDoubleTap&&this.options.onDoubleTap(this,a))},computeInitialOffset:function(){this.initialOffset={x:-c(this.el.offsetWidth*this.getInitialZoomFactor()-this.container.offsetWidth)/2,y:-c(this.el.offsetHeight*this.getInitialZoomFactor()-this.container.offsetHeight)/2}},resetOffset:function(){this.offset.x=this.initialOffset.x,this.offset.y=this.initialOffset.y},isImageLoaded:function(a){return"IMG"===a.nodeName?a.complete&&0!==a.naturalHeight:Array.from(a.querySelectorAll("img")).every(this.isImageLoaded)},setupOffsets:function(){this.options.setOffsetsOnce&&this._isOffsetsSet||(this._isOffsetsSet=!0,this.computeInitialOffset(),this.resetOffset())},sanitizeOffset:function(c){var d=this.el.offsetWidth*this.getInitialZoomFactor()*this.zoomFactor,e=this.el.offsetHeight*this.getInitialZoomFactor()*this.zoomFactor,f=d-this.getContainerX()+this.options.horizontalPadding,g=e-this.getContainerY()+this.options.verticalPadding,h=b(f,0),i=b(g,0),j=a(f,0)-this.options.horizontalPadding,k=a(g,0)-this.options.verticalPadding;return{x:a(b(c.x,j),h),y:a(b(c.y,k),i)}},scaleTo:function(a,b){this.scale(a/this.zoomFactor,b)},scale:function(a,b){a=this.scaleZoomFactor(a),this.addOffset({x:(a-1)*(b.x+this.offset.x),y:(a-1)*(b.y+this.offset.y)}),triggerEvent(this.el,this.options.zoomUpdateEventName),"function"==typeof this.options.onZoomUpdate&&this.options.onZoomUpdate(this,event)},scaleZoomFactor:function(c){var d=this.zoomFactor;return this.zoomFactor*=c,this.zoomFactor=a(this.options.maxZoom,b(this.zoomFactor,this.options.minZoom)),this.zoomFactor/d},canDrag:function(){return this.options.draggableUnzoomed||!f(this.zoomFactor,1)},drag:function(a,b){b&&(this.options.lockDragAxis?c(a.x-b.x)>c(a.y-b.y)?this.addOffset({x:-(a.x-b.x),y:0}):this.addOffset({y:-(a.y-b.y),x:0}):this.addOffset({y:-(a.y-b.y),x:-(a.x-b.x)}),triggerEvent(this.el,this.options.dragUpdateEventName),"function"==typeof this.options.onDragUpdate&&this.options.onDragUpdate(this,event))},getTouchCenter:function(a){return this.getVectorAvg(a)},getVectorAvg:function(a){return{x:a.map(function(a){return a.x}).reduce(e)/a.length,y:a.map(function(a){return a.y}).reduce(e)/a.length}},addOffset:function(a){this.offset={x:this.offset.x+a.x,y:this.offset.y+a.y}},sanitize:function(){this.zoomFactor<this.options.zoomOutFactor?this.zoomOutAnimation():this.isInsaneOffset(this.offset)&&this.sanitizeOffsetAnimation()},isInsaneOffset:function(a){var b=this.sanitizeOffset(a);return b.x!==a.x||b.y!==a.y},sanitizeOffsetAnimation:function(){var a=this.sanitizeOffset(this.offset),b={x:this.offset.x,y:this.offset.y},c=function(c){this.offset.x=b.x+c*(a.x-b.x),this.offset.y=b.y+c*(a.y-b.y),this.update()}.bind(this);this.animate(this.options.animationDuration,c,this.swing)},zoomOutAnimation:function(){if(1!==this.zoomFactor){var a=this.zoomFactor,b=this.getCurrentZoomCenter(),c=function(c){this.scaleTo(a+c*(1-a),b)}.bind(this);this.animate(this.options.animationDuration,c,this.swing)}},updateAspectRatio:function(){this.unsetContainerY(),this.setContainerY(this.container.parentElement.offsetHeight)},getInitialZoomFactor:function(){var b=this.container.offsetWidth/this.el.offsetWidth,c=this.container.offsetHeight/this.el.offsetHeight;return a(b,c)},getAspectRatio:function(){return this.el.offsetWidth/this.el.offsetHeight},getCurrentZoomCenter:function(){var a=this.offset.x-this.initialOffset.x,b=-1*this.offset.x-a/(1/this.zoomFactor-1),c=this.offset.y-this.initialOffset.y,d=-1*this.offset.y-c/(1/this.zoomFactor-1);return{x:b,y:d}},getTouches:function(a){var b=this.container.getBoundingClientRect(),c=document.documentElement.scrollTop||document.body.scrollTop,d=document.documentElement.scrollLeft||document.body.scrollLeft,e=b.top+c,f=b.left+d;return Array.prototype.slice.call(a.touches).map(function(a){return{x:a.pageX-f,y:a.pageY-e}})},animate:function(a,b,c,d){var e=new Date().getTime(),f=function(){if(this.inAnimation){var g=new Date().getTime()-e,h=g/a;g>=a?(b(1),d&&d(),this.update(),this.stopAnimation(),this.update()):(c&&(h=c(h)),b(h),this.update(),requestAnimationFrame(f))}}.bind(this);this.inAnimation=!0,requestAnimationFrame(f)},stopAnimation:function(){this.inAnimation=!1},swing:function(a){return-Math.cos(a*Math.PI)/2+.5},getContainerX:function(){return this.container.offsetWidth},getContainerY:function(){return this.container.offsetHeight},setContainerY:function(a){return this.container.style.height=a+"px"},unsetContainerY:function(){this.container.style.height=null},setupMarkup:function(){this.container=buildElement("<div class=\"pinch-zoom-container\"></div>"),this.el.parentNode.insertBefore(this.container,this.el),this.container.appendChild(this.el),this.container.style.overflow="hidden",this.container.style.position="relative",this.el.style.webkitTransformOrigin="0% 0%",this.el.style.mozTransformOrigin="0% 0%",this.el.style.msTransformOrigin="0% 0%",this.el.style.oTransformOrigin="0% 0%",this.el.style.transformOrigin="0% 0%",this.el.style.position="absolute"},end:function(){this.hasInteraction=!1,this.sanitize(),this.update()},bindEvents:function(){var a=this;g(this.container,this),this.resizeHandler=this.update.bind(this),window.addEventListener("resize",this.resizeHandler),Array.from(this.el.querySelectorAll("img")).forEach(function(b){b.addEventListener("load",a.update.bind(a))}),"IMG"===this.el.nodeName&&this.el.addEventListener("load",this.update.bind(this))},update:function(a){a&&"resize"===a.type&&(this.updateAspectRatio(),this.setupOffsets()),a&&"load"===a.type&&(this.updateAspectRatio(),this.setupOffsets());this.updatePlanned||(this.updatePlanned=!0,window.setTimeout(function(){this.updatePlanned=!1;var a=this.getInitialZoomFactor()*this.zoomFactor,b=-this.offset.x/a,c=-this.offset.y/a,d="scale3d("+a+", "+a+",1) translate3d("+b+"px,"+c+"px,0px)",e="scale("+a+", "+a+") translate("+b+"px,"+c+"px)",f=function(){this.clone&&(this.clone.parentNode.removeChild(this.clone),delete this.clone)}.bind(this);!this.options.use2d||this.hasInteraction||this.inAnimation?(this.is3d=!0,f(),this.el.style.webkitTransform=d,this.el.style.mozTransform=e,this.el.style.msTransform=e,this.el.style.oTransform=e,this.el.style.transform=d):(this.is3d&&(this.clone=this.el.cloneNode(!0),this.clone.style.pointerEvents="none",this.container.appendChild(this.clone),window.setTimeout(f,200)),this.el.style.webkitTransform=e,this.el.style.mozTransform=e,this.el.style.msTransform=e,this.el.style.oTransform=e,this.el.style.transform=e,this.is3d=!1)}.bind(this),0))},enable:function(){this.enabled=!0},disable:function(){this.enabled=!1},destroy:function(){window.removeEventListener("resize",this.resizeHandler),this.container&&(this.container.remove(),this.container=null)}};var g=function(a,b){var c=null,d=0,e=null,f=null,g=function(a,d){c!==a&&(c&&!a&&("zoom"===c?b.handleZoomEnd(d):"drag"===c?b.handleDragEnd(d):void 0),"zoom"===a?b.handleZoomStart(d):"drag"===a?b.handleDragStart(d):void 0);c=a},h=function(a){2===d?g("zoom"):1===d&&b.canDrag()?g("drag",a):g(null,a)},i=function(a){return Array.from(a).map(function(a){return{x:a.pageX,y:a.pageY}})},j=function(c,a){var d,e,b=Math.sqrt;return d=c.x-a.x,e=c.y-a.y,b(d*d+e*e)},k=function(a,b){var c=j(a[0],a[1]),d=j(b[0],b[1]);return d/c},l=function(a){a.stopPropagation(),a.preventDefault()},m=function(a){var f=new Date().getTime();1<d&&(e=null);300>f-e?(l(a),b.handleDoubleTap(a),"zoom"===c?b.handleZoomEnd(a):"drag"===c?b.handleDragEnd(a):void 0):b.isDoubleTap=!1;1===d&&(e=f)},n=!0;a.addEventListener("touchstart",function(a){b.enabled&&(n=!0,d=a.touches.length,m(a))},{passive:!1}),a.addEventListener("touchmove",function(a){b.enabled&&!b.isDoubleTap&&(n?(h(a),c&&l(a),f=i(a.touches)):("zoom"===c?2==f.length&&2==a.touches.length&&b.handleZoom(a,k(f,i(a.touches))):"drag"===c?b.handleDrag(a):void 0,c&&(l(a),b.update())),n=!1)},{passive:!1}),a.addEventListener("touchend",function(a){b.enabled&&(d=a.touches.length,h(a))})};return d};window.PinchZoom=definePinchZoom();})();

/*! once */
function once(n,o){var t;if("function"!=typeof n)throw new TypeError("func is not a function");return void 0===o&&(o=2),o=parseInt(o),function(){return--o>0&&(t=n.apply(this,arguments)),o<=1&&(n=void 0),t}}

function urlParam (name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  return (results == null) ? null : results[1];
}

function isMobile () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|WomensBestApp/i.test(navigator.userAgent);
}

/*** COOKIES ***/
(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };
  var ref = getUrlParameter("awebook");
  var domain = '.womensbest.com';
  if(ref && ref.length>0){
    Cookies.set('awinEbook', true, {expires: 1, path: '/', domain: domain});
    window.location.hash = '';
  }
  var refDiscount = getUrlParameter("discount");
  if(refDiscount && refDiscount.length>0){
    Cookies.set('discount', refDiscount, {expires: 0.04, path: '/', domain: domain});
    window.location.hash = '';
  }
  if (window.location.hash === '#vfb') {
    //console.log('fbcookie');
    Cookies.set('vfb', 'tracking', {expires: 7, path: '/', domain: domain});
    window.location.hash = '';
  }

  if (window.location.hash === '#fbadhouse') {
    Cookies.set('adfb', 'tracking', {expires: 2, path: '/', domain: domain});
    window.location.hash = '';
  }
  if (window.location.hash === '#igadhouse') {
    Cookies.set('adig', 'tracking', {expires: 2, path: '/', domain: domain});
    window.location.hash = '';
  }
  var sbAffSub = getUrlParameter('aff_sub');
  if (sbAffSub) {
    Cookies.set('sb_aff_sub', sbAffSub, {expires: 30, path: '/', domain: domain});
    window.location.hash = '';
  }
  //Order Note Tracking
  if (window.location.hash === '#special-offer') {
    Cookies.set('SONoteTracking', 'special-offer', {expires: 14, path: '/', domain: domain});
    Cookies.set('special-offer', 1, {expires: 14, path: '/', domain: domain});
    window.location.hash = '';
  }
  if (window.location.hash === '#special-offer-black-friday') {
    Cookies.set('SONoteTracking', 'special-offer', {expires: 14, path: '/', domain: domain});

  }
  if (window.location.hash === '#black-friday') {
    Cookies.set('SONoteTracking', 'black-friday', {expires: 14, path: '/', domain: domain});
    window.location.hash = '';
  }
  if (window.location.hash === '#retargeting') {
    Cookies.set('SONoteTracking', 'retargeting', {expires: 14, path: '/', domain: domain});
    window.location.hash = '';
  }
  if (window.location.hash === '#trbotest') {
    Cookies.set('trbo', 'test', {expires: 14, path: '/', domain: domain});
    window.location.hash = '';
  }

})();
function attributeToString(t) {
  return "string" != typeof t && "undefined" === (t += "") && (t = ""),
    jQuery.trim(t)
}

window.WBupdateCartNote = function(t, r) {
  var e = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(t),
    dataType: "json",
    success: function(t) {
      console.log('cart note updated with '+JSON.stringify(t.note));
    },
    error: function(t, r) {
      console.log('error on cart note update');
    }
  };
  jQuery.ajax(e)
}
var SwiperLazyLoad = {
  init: function (options) {
    var swiper = this;
    if (swiper.destroyed || swiper.lazyLoad.lazyLoadInstance) {
      return;
    }

    var newCallbackLoaded = swiper.params.lazyLoad.options.callback_loaded;

    if (swiper.params.lazyLoad.loadPrevNext) {
      var loadInOnce = once(function () {
        setTimeout(function () {
          if (document.readyState === 'complete' || document.readyState === 'loaded') {
            swiper.lazyLoad.loadNextPrev();
          } else {
            window.addEventListener('load', swiper.lazyLoad.loadNextPrev);
          }
        }, 100);
      });

      if (typeof swiper.params.lazyLoad.options.callback_loaded !== 'undefined') {
        newCallbackLoaded = function (el) {
          loadInOnce();
          options.callback_loaded.call(this, el);
        }
      } else {
        newCallbackLoaded = loadInOnce;
      }
    }

    var id = swiper.$el.attr('id');
    if (!id) {
      console.error('Swiper lazyLoad requires an id on .swiper-container');
      return;
    }

    swiper.lazyLoad.lazyLoadInstance = new LazyLoad(Object.assign({}, swiper.params.lazyLoad.options, {
      container: swiper.params.lazyLoad.contained === false
      ? window.document
      : swiper.params.lazyLoad.contained === true
      ? swiper.$el[0]
      : document.querySelector(swiper.params.lazyLoad.contained),
      elements_selector: '#' + id + ' ' + swiper.params.lazyLoad.options.elements_selector,
      callback_loaded: newCallbackLoaded
    }));
  },
  update: function () {
    var swiper = this;
    swiper.lazyLoad.lazyLoadInstance.update();
  },
  loadAll: function () {
    var swiper = this;
    swiper.lazyLoad.lazyLoadInstance.loadAll();
  },
  load: function (element, force) {
    var swiper = this;
    if (typeof swiper.lazyLoad.lazyLoadInstance.load === 'function') {
      swiper.lazyLoad.lazyLoadInstance.load(element, force);
    } else {
      LazyLoad.load(element, swiper.lazyLoad.lazyLoadInstance._settings)
    }
  },
  destroy: function () {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.initialized || !swiper.lazyLoad.lazyLoadInstance) {
      return;
    }
    swiper.lazyLoad.lazyLoadInstance.destroy();
    window.removeEventListener('load', swiper.lazyLoad.loadNextPrev);
  },
  slideExist: function (index) {
    var swiper = this;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    if (isVirtual) {
      if (swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
        return true;
      }
    } else if (swiper.slides[index]) { return true; }
    return false;
  },
  loadInSlide: function (index) {
    var swiper = this;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    if (typeof index === 'undefined' || swiper.slides.length === 0 || !swiper.lazyLoad.lazyLoadInstance) {
      return;
    }

    var $slideEl = isVirtual
    ? swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + index + '"]')
    : swiper.slides.eq(index);

    var options = swiper.lazyLoad.lazyLoadInstance._settings;
    var selector = (options.elements_selector + ':not(.' + options.class_loaded + '):not(.' + options.class_loading + ')');

    $slideEl.each(function (elIndex, slideEl) {
      slideEl.querySelectorAll(selector).forEach(function(imageEl) {
        swiper.lazyLoad.load(imageEl);
      });
    });
  },
  loadNextPrev: function () {
    var swiper = this;
    if (swiper.params.lazyLoad.enabled && swiper.params.lazyLoad.loadPrevNext) {
      var slidesPerView = swiper.params.slidesPerView === 'auto' ? 0 : swiper.params.slidesPerView;
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var amount = swiper.params.lazyLoad.loadPrevNextAmount;

      if (slidesPerView > 0) {
        var realIndex = swiper.realIndex;
        var maxIndex = Math.min(realIndex + Math.max(slidesPerView, amount), swiper.slides.length - 1);
        var minIndex = Math.max(realIndex - Math.max(slidesPerView, amount), 0);
        for (var iNext = realIndex + slidesPerView; iNext < maxIndex; iNext += 1) {
          if (SwiperLazyLoad.slideExist.call(swiper, iNext)) {
            swiper.lazyLoad.loadInSlide(iNext);
          }
        }
        for (var iPrev = minIndex; iPrev < realIndex; iPrev += 1) {
          if (SwiperLazyLoad.slideExist.call(swiper, iPrev)) {
            swiper.lazyLoad.loadInSlide(iPrev);
          }
        }
      }
    }
  }
};

var SwiperLazyLoad$1 = {
  name: 'lazyLoad',
  params: {
    lazyLoad: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      contained: false, // false (default to document), true (swiper el itself), selector for custom el
      options: {
        elements_selector: '.slider-lazy',
        threshold: 0,
        class_loading: 'slider-lazy--loading',
        class_loaded: 'slider-lazy--loaded',
        class_error: 'slider-lazy--error',
      }
    }
  },
  on: {
    beforeInit: function () {
      var swiper = this;
      if (swiper.params.lazyLoad.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function () {
      var swiper = this;
      if (swiper.params.lazyLoad.enabled) {
        SwiperLazyLoad.init.call(swiper);
      }
    },
    observerUpdate: function () {
      var swiper = this;
      if (swiper.params.observer && swiper.params.lazyLoad.enabled) {
        SwiperLazyLoad.update.call(swiper);
      }
    },
    slideChange: function () {
      SwiperLazyLoad.loadInSlide.call(this, this.activeIndex);
      SwiperLazyLoad.loadNextPrev.call(this);
    },
    destroy: function () {
      SwiperLazyLoad.destroy.call(this);
    }
  },
  create: function () {
    var swiper = this;
    var id = swiper.$el.attr('id');
    if (!id) {
      throw new Error('Swiper container does not have an id');
    }

    // Utils.extend
    Object.assign(swiper, {
      lazyLoad: {
        update: SwiperLazyLoad.update.bind(swiper),
        loadAll: SwiperLazyLoad.loadAll.bind(swiper),
        load: SwiperLazyLoad.load.bind(swiper),
        loadInSlide: SwiperLazyLoad.loadInSlide.bind(swiper),
        loadNextPrev: SwiperLazyLoad.loadNextPrev.bind(swiper)
      }
    });
  }
};

Swiper.use([SwiperLazyLoad$1]);

/*
<div data-equal-height="container">
  <div data-equal-height="item">
    <div data-equal-height="example">...</div>
  </div>
  <div data-equal-height="item">
    <div data-equal-height="example">...</div>
  </div>
</div>
*/

window.EqualHeight = function (options) {
  options = options || {};
  let attribute = options.attribute || 'data-equal-height';
  let container = '[' + attribute + '="container"]';
  let itemSelector = '[' + attribute + '="item"]';
  let sameHeightSelector = '[' + attribute + ']';

  let containerElements = [];
  let itemElements = [];

  function findPosition(item) {
    if (item && !item.matches(container)) {
      let pos = findPosition(item.offsetParent);
      pos.x += item.offsetLeft;
      pos.y += item.offsetTop;
      return pos;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }

  function findMaxHeight(items, cache) {
    return Math.max.apply(null, items.map(function (item) {
      if (item.style.height !== '') {
        item.style.height = null;
      }
      return item.offsetHeight;
      /*if (typeof item.dataset.equalHeightCache === 'undefined' || cache === false) {
        if (item.style.height !== '') {
          item.style.height = null;
        }
        item.dataset.equalHeightCache = item.offsetHeight;
      }
      return parseFloat(item.dataset.equalHeightCache);
      */
    }));
  }

  function setHeight(items, height) {
    if (height === 0) {
      items.forEach((item)=> {
        // console.log("22222222",item.className)
        if (item.className !== 'wb-item__subline alg_subline') {
          item.style.display = 'none';
        }
      });
      return;
    }
    let newHeight = height.toString() + 'px';
    items.forEach(function (item) {
      item.style.height = newHeight;
      if (item.style.display === 'none') {
        item.style.display = null;
      }
    });
  }

  function resetHeight(items) {
    items.forEach(function (item) {
      item.style.display = null;
      item.style.height = null;
    });
  }

  function getSameHeightElements(item) {
    return Array.prototype.slice.call(item.querySelectorAll(sameHeightSelector));
  }

  function applySameHeight(items, cache) {
    let sameHeightElements = {};
    items.filter(function (item) { return item !== null; }).forEach(function (item) {
      getSameHeightElements(item).forEach(function (sameHeightElement) {
        let type = sameHeightElement.getAttribute(attribute);
        if (typeof sameHeightElements[type] === 'undefined') { sameHeightElements[type] = []; }
        sameHeightElements[type].push(sameHeightElement);
      });
    });
    Object.values(sameHeightElements).forEach(function (items) {
      let height = findMaxHeight(items, cache);
      setHeight(items, height);
    });
    // console.log({ items, sameHeightElements });
  }

  function groupItemsByRow(items) {
    let rows = {};
    let rowIndex = 0;
    items.forEach(function(item, index) {
      let position = findPosition(item);
      // console.log({position, item});
      if (typeof rows[position.y] === 'undefined') {
        rows[position.y] = [];
      }
      rows[position.y].push(items[index])
    });
    // console.log(Object.values(rows));
    return Object.values(rows);
  }

  function shopGridExists() {
    return typeof window.$gbl_grid !== 'undefined' && window.$gbl_grid.length > 0;
  }

  function isShopGrid(element) {
    return shopGridExists() && window.$gbl_grid[0] === element;
  }

  function isSwiper(element) {
    if (typeof element.swiper !== 'undefined') {
      return true;
    }
    if (element.classList.contains('swiper-container')) {
      return true;
    }
    return element.querySelector('.swiper-slide') !== null;
  }

  function getItems(containerElement) {
    return Array.prototype.slice.call(containerElement.querySelectorAll(itemSelector)).filter((element) => element.offsetParent !== null);
  }

  function loadAll() {
    containerElements = Array.prototype.slice.call(document.querySelectorAll(container));
    itemElements = containerElements.map(getItems);
    // console.log({ containerElements, itemElements });
  }

  function layoutItems(index, args) {
    args = args || {};
    let containerElement = containerElements[index];
    let isGrid = isShopGrid(containerElement);
    if (args.ignoreShopGrid === true && isGrid) { return; }
    if (args.ignoreSwiper === true && isSwiper(containerElement)) { return; }
    let cache = typeof args.cache === 'undefined' ? !isGrid : args.cache;
    if (!isSwiper(containerElement)) {
      groupItemsByRow(itemElements[index]).forEach(function (row) { applySameHeight(row, cache); });
      // console.log(index, containerElement, groupItemsByRow(itemElements[index]));
    } else {
      applySameHeight(itemElements[index], cache);
    }
  }

  function layoutAll(args) {
    containerElements.forEach(function(containerElement, index) {
      layoutItems(index, args || {});
    });
  }
  
  const loadAllThrottled = throttle(150, loadAll);
  
  const layoutAllThrottled = throttle(150, layoutAll);

  function update(args) {
    loadAllThrottled();
    layoutAllThrottled(args);
  }

  function onResize() {
    loadAllThrottled();
    layoutAllThrottled({ ignoreShopGrid: true, cache: true });
  }

  function resetGrid(element) {
    let index = containerElements.indexOf(element);
    if (index === -1) { return; }
    itemElements[index].forEach(function(item) { resetHeight(getSameHeightElements(item)); });
  }

  function updateGrid(element, filteredItems) {
    let index = containerElements.indexOf(element);
    if (index === -1) { return; }
    if (typeof filteredItems === 'undefined') {
      itemElements[index] = getItems(containerElements[index]);
      layoutItems(index, { cache: true });
    } else {
      let rows = filteredItems.reduce(function (itemElements, item) {
        if (typeof itemElements[item.row] === 'undefined') {
          itemElements[item.row] = [];
        }
        itemElements[item.row].push(item.element.querySelector(itemSelector));
        return itemElements;
      }, {});
      Object.values(rows).filter(function(row) { return row !== null; }).forEach(function (row) {
        applySameHeight(row, false);
      });
    }
  }

  function destroy() {
    window.removeEventListener('resize', onResize, false);
    containerElements = [];
    itemElements = [];
  }

  update();
  window.addEventListener('resize', onResize, false);

  return {
    update: update,
    updateGrid: updateGrid,
    resetGrid: resetGrid,
    destroy: destroy,
  };
};

document.addEventListener('DOMContentLoaded', function () {

  if (window.GeoRedirect) {
    var ipCache = GeoRedirect.getIpShopCache();
    if (ipCache && ipCache.country_code){
      document.documentElement.classList.add('country-'+ipCache.country_code);
    }
  }

  var lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
  });
  window.lazyLoadInstance = lazyLoadInstance;

  window.equalHeightInstance = new EqualHeight();

  setTimeout(function initSeenonSlider() {
    var sliderId = '#seenon_slider';
    var elSwiper = document.getElementById(sliderId.slice(sliderId.indexOf('#') + 1));

    if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
      return;
    }

    var swiper = new Swiper(elSwiper, {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      roundLengths: true, //prevent blurry text
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
      },
      breakpoints: {
        768: {
          slidesPerView: 6
        },
        992: {
          slidesPerView: 6
        },
        1920: {
          slidesPerView: 7
        }
      },
      lazyLoad: true
    });
  }, 2000);


  /* cookies notification safari workaround */
  (function () {
    var days = 60;
    function checkCNcookie() {
      var cnData = Cookies.getJSON('cookiesNotification');
      if (!cnData) {
        return;
      }
      var expiresAtTime = new Date(new Date(cnData[0].savedAt).getTime() + (days * 24 * 60 * 60 * 1000)).getTime();
      window.localStorage.setItem('cookiesNotification', expiresAtTime);
    }
    function updateCNcookie() {
      var expiresAtTime = parseInt(window.localStorage.getItem('cookiesNotification') || 0);
      var isExpired = new Date().getTime() > expiresAtTime;
      if (isExpired) {
        return;
      }
      var cnString = Cookies.get('cookiesNotification') || JSON.stringify([{ savedAt: new Date().toISOString() }]);
      Cookies.set('cookiesNotification', cnString, { expires: days });
    }
    setTimeout(function () {
      checkCNcookie();
      updateCNcookie();
    }, 10);
  })();


  (function () {
    var scrolltoelement = urlParam("scrollto");
    if (scrolltoelement != null) {
      $elements = $("#"+scrolltoelement+", ." + scrolltoelement);
      if ($elements.length > 0) {
        //$element = $elements[0];
        var body = $("html, body");
        setTimeout(function() {
          body.stop().animate({scrollTop:Number($($elements[0]).offset().top)-150}, '1000');
        }, 1000);
      }
    }
  })();

  // Newsletter Lead Tracking
  $('#wb-mailchimp-signup-footer').submit(function(e){
    fbq('track', 'Lead', {content_category:'Footer Newsletter Input', value: $('.wb-footer__newsletter-input').val()});
  });

  (function () { //fix recharge postal code rename bug
    if($('.wb-de label[for="billing_postalcode"]').length>0){
      var targetNodes         = $('.wb-de label[for="billing_postalcode"]');
      var MutationObserver    = window.MutationObserver || window.WebKitMutationObserver;
      var myObserver          = new MutationObserver (mutationHandler);
      var obsConfig           = { childList: true, characterData: true, attributes: true, subtree: true };

      //--- Add a target node to the observer. Can only add one node at a time.
      targetNodes.each ( function () {
        myObserver.observe (this, obsConfig);
      } );

      function mutationHandler (mutationRecords,observer) {
        //console.info ("mutationHandler:");

        mutationRecords.forEach ( function (mutation) {
          //console.log (mutation.type + $('.wb-de label[for="billing_postalcode"]').text());
          if (typeof mutation.removedNodes == "object") {
            var jq = $(mutation.removedNodes);
            //console.log (jq+$('.wb-de label[for="billing_postalcode"]').text());
            if($('.wb-de label[for="billing_postalcode"]').text()!='Postleitzahl'){
              $('.wb-de label[for="billing_postalcode"]').text('Postleitzahl');
            }
          }
        });
      }
    }
  })();
  if($('.wb-hero-banner-gif').length>0){
    setTimeout(function(){
      $('.wb-hero-banner-gif-lazy').hide()
      $('.wb-hero-banner-gif').show()
    },3000);
  }

  function readMore(element, desc) {
    if (element.length < 1) {
      return;
    }
    element.each(function () {
      var height = $(this).height() + 30;
      var isDesktop = window.innerWidth >= 768;
      var maxheight = 200;
      
      var step1 = 200;
      var step2 = isDesktop ? 1800 : 600;
      var step3 = isDesktop ? 3400 : 1000;
      
      if (desc == true) {
        var maxheight = 600;
      }

      if (height < maxheight) {
        return;
      }

      var $that = $(this);
      var moreBtnClass = 'wb-readmore-btn';
      var lessBtnClass = 'wb-readless-btn';
      var moreBtn = "<div class='" + moreBtnClass + "'>Show more</div>";
      var lessBtn = "<div class='" + lessBtnClass + "'>Show less</div>";

      if ($('html').hasClass('wb-de')) {
        var moreBtn = "<div class='" + moreBtnClass + "'>Mehr anzeigen</div>";
        var lessBtn = "<div class='" + lessBtnClass + "'>Weniger anzeigen</div>";
      } else if ($('html').hasClass('wb-fr')) {
        var moreBtn = "<div class='" + moreBtnClass + "'>Voir plus</div>";
        var lessBtn = "<div class='" + lessBtnClass + "'>Voir moins</div>";
      }


      $(this).attr('data-height', height);
      $(this).addClass('wb-readmore');

      $(this).append(moreBtn);
      $(this).append(lessBtn);

      $that.find('.' + moreBtnClass).click(function () {
        if (desc == false || true) {
          if($that.height() < step2 && height > step2) {
            $that.height(step2);
          } else if($that.height() < step3 && height > step3) {
            $that.height(step3);
          } else {
            $that.height(height);
            $that.toggleClass('wb-readmore-shown');  
          }
        } else {
          $that.height(height);
          $that.toggleClass('wb-readmore-shown');
        }
        
        
      });
      $that.find('.' + lessBtnClass).click(function () {
        $that.height('');
        $that.toggleClass('wb-readmore-shown');
      });
    });
  }

  readMore($('.product-content__description'),true);
  readMore($('.product-info-banner__text'),false);

  
}, { passive: true });

/// Smile.IO ///

$(document).on('sweettooth-ready', function(e) {
  //reset the inline z-index important form smile
  $('#smile-ui-container').css('z-index','2147483645')

  // add , on high numbers
  $.fn.digits = function(){
    var separator = '';
    try {
      switch (document.documentElement.lang.split('-')[0]) {
        case 'de':
          separator = '.';
          break;
        case 'fr':
          separator = ' ';
          break;
        default:
          separator = ',';
          break;
      }
    } catch (e) {
      //
    }

    return this.each(function(){
      $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1"+separator) );
    });
  };

  // customer account
  /*if($('.leftPoints').length > 0){*/
  if($('.sweettooth-points-balance').text() < 5000){
    var leftpoints = 5000 - $('.sweettooth-points-balance').text();

    $('.leftPoints').text(leftpoints);
  }else{
    $('.wb-account-smile .alert-warning').hide();

  }


  SweetTooth.fetchCustomer().then(function(customer) {
    var tierID = customer.vip_tier_id;
    //console.log(tierID);
    if(tierID == wbRewardsClub.TierBronzeID){

      //console.log('Bronze customer');
      $('html').addClass('vip-tier-1');
    }else if(tierID == wbRewardsClub.TierSilverID){

      //console.log('Silver customer');
      $('html').addClass('vip-tier-2');
      $('.bp-spent-per-amount').text('125');

    }else if(tierID == wbRewardsClub.TierGoldID){

      //console.log('Gold customer');
      $('html').addClass('vip-tier-3');
      $('.bp-spent-per-amount').text('150');
    }
  }).catch(function (e) {
    //console.log('no customer', e);
  });
  //}

  // header
  //$('.wb-header__bottom .col-lg-4:nth-child(2)').html('<p class="text-center tablet-fontsize" style="cursor:pointer;" data-st-intent="st:points:home"> <img style="width:20px; position: relative; margin-right: 5px; top: -1px;" src="https://cdn.shopify.com/s/files/1/0744/0203/files/bestpoints_gold_140031bd-c694-419d-9bda-efea3ee6933c.svg?6878181801665486860"/>Bonus Points on every Order</p>')
  // footer
  $('.bp_footer').show(100);

  if($('.sweettooth-points-balance').length) {
    $('.sweettooth-points-balance').digits();
    $('.sweettooth-points-balance').show(100);
  }
  if($('.digits').length){
    $('.digits').digits();
  }

  setTimeout(function() {

    var smileContainer = document.getElementById('smile-ui-container');
    if (!smileContainer) {
      return;
    }

    if (window.location.pathname.includes('/collections/shop-fitness')) {
      return;
    }
    smileContainer.style.opacity = 1;

    var smileFrame = smileContainer.querySelector('.smile-launcher-frame');
    if (!smileFrame) {
      return;
    }

   var smileStyles = document.createElement('style');
    smileStyles.innerText = '\
.launcher-container { height: 48px; display: flex; padding: 15px; } \
.launcher-container.smile-launcher-image-only { padding: 8px 7px 7px; } \
.launcher-container .launcher-text { font-size: 14px; line-height: 1; text-align: left; margin-left: 8px!important; display:none; } \
.wb-launcher-text { font-size:14px;line-height:1;text-align: left; font-weight:600; position: relative;top: 1px; } \
.wb-launcher-text--club { font-size:13px; font-weight:400; } \
.launcher-container .launcher-content-container .launcher-icon { position: relative; top: -1px; } \
.launcher-container .launcher-mobile-only { margin: 8px 6px 8px 10px; } \
.launcher-container .launcher-close-icon { margin: 11px; } \
';
    smileFrame.contentDocument.head.appendChild(smileStyles);

    var smileText = smileFrame.contentDocument.body.querySelector('.launcher-text');
    if (smileText) {
      smileText.insertAdjacentHTML('beforebegin', '<span class="wb-launcher-text">REWARDS<br><span class="wb-launcher-text--club">CLUB</span></span>'); 
    }

    smileFrame.style.opacity = 1;

  }, 1000);

});



(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.search.includes('allow-copy=1')) {
      Cookies.set('allow_copy', '1', { expires: 30, path: '/', domain: '.womensbest.com' });
    }
    if (Cookies.get('allow_copy', { domain: '.womensbest.com' }) === '1') {
      document.body.classList.add('allow-copy');
    }
  });
})();